import { Component } from 'react'
// Components
import { IconQuote, Shelf } from '@tracklib/kit'
import { IconBox } from 'kit'

import styles from './quotesblock.css'

type QuoteProps = {
  name: string
  text: string
  image: number
  description: string
}

export const Quote = ({ name, text, image, description }: QuoteProps): JSX.Element => (
  <IconBox image={image} icon={<IconQuote />}>
    <span className={styles.textWrapper}>
      <span />
      <span className={styles.text}>{text}</span>
      <div className={styles.info}>
        <h2 className={styles.name}>{name}</h2>
        <p className={styles.description}>{description}</p>
      </div>
    </span>
  </IconBox>
)

type QuotesBlockProps = {
  value: {
    quotes: Array<{
      name: string
      image: number
      text: string
      description: string
    }>
    override_margin_bottom: number
  }
}

class QuotesBlock extends Component<QuotesBlockProps> {
  shouldComponentUpdate(nextProps: QuotesBlockProps) {
    if (this.props.value.quotes.length !== nextProps.value.quotes.length) {
      return true
    }
    return false
  }

  render() {
    const {
      value: { quotes, override_margin_bottom },
    } = this.props
    return (
      <Shelf marginBottom={override_margin_bottom} className={styles.wrapper} datatesting="quotes_block">
        {quotes.slice(0, 4).map(({ name, text, image, description }) => (
          <Shelf.Item key={name}>
            <Quote name={name} text={text} image={image} description={description} />
          </Shelf.Item>
        ))}
      </Shelf>
    )
  }
}

export default QuotesBlock
